// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#floatAdd{height:66px;width:66px}#floatAdd>i{position:absolute;display:inline-block;border-radius:0.375rem;--tw-bg-opacity:1;background-color:rgba(112, 112, 112, var(--tw-bg-opacity));height:6px;left:15px;top:30px;width:36px}#floatAdd>b{position:absolute;display:inline-block;border-radius:0.375rem;--tw-bg-opacity:1;background-color:rgba(112, 112, 112, var(--tw-bg-opacity));top:15px;left:30px;height:36px;width:6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
